import UPLOAD_ICON from "@/assets/icons/upload.svg";
import { ChangeEvent, FC } from "react";
import "./style.scss";

interface SelectImagePropTypes {
  desc?: string;
  disabled?: boolean;
  displayIcon?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  width?: string;
  multiple?: boolean;
  isError?: boolean;
  errorText?: string;
}

const SelectImage: FC<SelectImagePropTypes> = ({
  desc,
  disabled,
  displayIcon,
  onChange = () => {},
  width = "428px",
  multiple,
  isError = false,
  errorText,
}) => {
  return (
    <div>
      <div
        className={
          "select-image-component-wrapper" + (disabled ? " disabled" : "")
        }
        style={{ height: displayIcon ? "126px" : "74px", width }}
      >
        <label htmlFor="select-image-trigger" className="icon-section">
          {displayIcon && <img src={UPLOAD_ICON} alt="upload-icon" />}
          <span>Click to upload</span>
        </label>
        <input
          type="file"
          id="select-image-trigger"
          disabled={disabled}
          onChange={onChange}
          multiple={multiple}
        />

        <span className="description-text">{desc}</span>
      </div>
      {isError && (
        <span className="select-image-component-error-text">{errorText}</span>
      )}
    </div>
  );
};

export default SelectImage;
